import APN from './fr/APN.fr-BE';
import FAQ from './fr/FAQ.fr-BE';
import UserManagment from './fr/UserManagment.fr-BE';
import account from './fr/account.fr-BE';
import advertisementPicturesManagement from './fr/advertisementPicturesManagement.fr-BE';
import autodebit from './fr/autodebit.fr-BE';
import balanceShare from './fr/balanceShare.fr-BE';
import bill from './fr/bill.fr-BE';
import businessUser from './fr/businessUser.fr-BE';
import custom from './fr/custom.fr-BE';
import login from './fr/login.fr-BE';
import member from './fr/member.fr-BE';
import memberBundle from './fr/memberBundle.fr-BE';
import mySupportManagement from './fr/mySupportManagement.fr-BE';
import order from './fr/order.fr-BE';
import overview from './fr/overview.fr-BE';
import sysParam from './fr/sysParam.fr-BE';
import systemLog from './fr/systemLog.fr-BE';
import ticket from './fr/ticket.fr-BE';
import transactionHistory from './fr/transactionHistory.fr-BE';
import verticalPrivilege from './fr/verticalPrivilege.fr-BE';

export default {
  'menu.login': 'Login',
  'menu.userMgr': 'User',
  'menu.portalMgr': 'Portal',
  'menu.menuMgr': 'Menu',
  'menu.roleMgr': 'Role',
  'menu.home': 'Home',
  'menu.access': 'Access',
  'menu.crud': 'CRUD',
  'menu.usermanagment': 'User Management',
  //common
  'common.OK': 'OK',
  'common.cancel': 'Cancel',
  'common.new': 'New',
  'common.unchanged': 'Unchanged',
  'common.edit': 'Edit',
  'common.url': 'URL',
  'common.name': 'Name',
  'common.userName': 'User Name',
  'common.userCode': 'User Code',
  'common.privCode': 'Priv Code',
  'common.state': 'State',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.portalId': 'Portal ID',
  'common.portalName': 'Portal Name',
  'common.portalUrl': 'Portal URL',
  'common.extraUrl': 'Extra URL',
  'common.defaultPortal': 'Default Portal',
  'common.menuName': 'Menu Name',
  'common.menuUrl': 'Menu URL',
  'common.addChildren': 'Add Children',
  'common.roleName': 'Role Name',
  'common.confirm': 'Confirm',
  'common.logout': 'Logout',
  'common.query': 'Query',
  'common.export': 'Export',
  'common.hello': 'hello',
  'common.detail': 'Detail',
  'common.delete': 'Delete',
  'common.submit': 'Submit',
  'common.msisdn': 'MSISDN',
  'common.operation': 'Operation',
  'common.modify': 'Modify',
  'common.save': 'Save',
  'common.add': 'Add',
  'common.must.be.number': 'Must be a number',
  'common.english': 'English',
  'common.français': 'Français',
  'common.changePassword': 'Change Password',
  'common.modifyPassword': 'Modify Password',
  'common.oldPassword': 'Old Password',
  'common.newPassword': 'New Password',
  'common.confirmPassword': 'Confirm Password',
  'common.inconsistentPpassword': 'Inconsistent password',
  'common.reset': 'Reset',
  'common.remarks': 'Remarks',
  'common.noAccess': 'Sorry, you are not authorized to access this page.',
  'common.nodata': 'No data',
  'common.changePasswordSuccess': 'Change password successfully',
  'common.includeExpiredAccount': 'Include Expired Account',
  'common.expired': 'Expired',
  'common.signup': 'Sign up',
  'common.signing': 'Signing...',
  'common.feature': 'Feature',
  'common.uploadSuccessfully': 'Upload successfully!',
  'common.uploadBackground': 'Upload Background image',
  'common.uploadlogo': 'Upload logo image',
  'common.uploadBanner': 'Upload banner',
  'common.reSelect': 'Re-select',
  'common.month': 'Month',
  'imageConfig.maximumImage': 'Maximum image size is ',
  'imageConfig.5M': '5M',
  'imageConfig.supportFormat': ', support format: jpg, png. jpeg.Recommended size',
  'imageConfig.supportFormat1': ', support format: jpg, png. jpeg.',
  'imageConfig.imageSize1': '2280px*1920px',
  'imageConfig.imageSize2': '2280px*600px',
  'imageConfig.GRB': 'GRB',
  // form
  'form.please.input': 'Please Input',
  'form.please.select': 'Please Select',
  'form.query': 'Query',
  'form.reset': 'Reset',
  //portalmgr
  'portalMgr.portalMenuSelector': 'Portal Menu Selector',
  'portalMgr.directoryMenuSeletor': 'Directory & Menu Selector',
  'portalMgr.directoryMenuName': 'Directory & Menu Name',
  'portalMgr.deleteTitle': 'This portal has directories or menus.',
  'portalMgr.deleteDesc': 'Do you want to delete them together?',
  'portalMgr.deleteMenuDesc':
    'Are you sure to delete the selected menu or directory?',
  // footer
  'footer.About': 'À propos de',
  'footer.History': 'Historique',
  'footer.Mission & Vision': 'Mission et vision',
  'footer.Leadership': 'Leadership',
  'footer.Newsroom': "Salle d'édition",
  'footer.Personal': 'Personnel',
  'footer.Services': 'Services',
  'footer.Phone Deals': 'Transactions téléphoniques',
  'footer.Device Trade-In': 'Remplacement du matériel',
  'footer.ConnectRwanda Promotion': 'Connecting Rwanda promotion',
  'footer.Help': "À l'aide!",
  'footer.Data Smart': 'Intelligence des données',
  'footer.Yolo': 'Yolo.',
  'footer.Blog': 'Blogs',
  'footer.Events': 'Événements',
  'footer.Bundles': 'Bale',
  'footer.MTN Yolo Hackatho': 'Mr. Yolo hakato',
  'footer.MoMo': 'Momo.',
  'footer.Agent': 'Agents',
  'footer.Merchant': "Hommes d'affaires",
  'footer.Corporates': 'Entreprises',
  'footer.Developers': 'Développeurs',
  'footer.Business': 'Opérations',
  'footer.Solutions': 'Résolution',
  'footer.Play': 'Jouer',
  'footer.Latest content': 'Mise à jour',
  'footer.mw1.rev': '2021 MTN Rwanda, tous droits réservés',
  'footer.mw1.tern': 'Conditions générales',
  'footer.mw1.privay': 'Politique de confidentialité',
  'footer.bol': '2021 BOL, tous droits réservés',
  ...login,
  ...overview,
  ...businessUser,
  ...account,
  ...member,
  ...order,
  ...balanceShare,
  ...FAQ,
  ...bill,
  ...ticket,
  ...APN,
  ...UserManagment,
  ...systemLog,
  ...verticalPrivilege,
  ...advertisementPicturesManagement,
  ...sysParam,
  ...autodebit,
  ...transactionHistory,
  ...mySupportManagement,
  // 最高优先级,后面的加在上面
  ...custom,
  ...memberBundle,
};
